// Slow editorial marquee band.
export default function Marquee({ items }) {
  const doubled = [...items, ...items];
  return (
    <div className="velvet border-y border-gold/20 py-5 overflow-hidden marquee-mask" data-testid="marquee">
      <div className="marquee-track">
        {doubled.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-2xl sm:text-3xl text-ivory/90 px-8">{t}</span>
            <span className="text-gold text-xl">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
